import { Box, Typography } from '@mui/material'
import LobbyNavbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import lobbyStyles from './lobbyStyles'


export default function LobbyLayout({ children, title }) {
  const classes = lobbyStyles()
  return (
    <Box className={classes.root}>
      <LobbyNavbar />
      <Box className={classes.backgroundImage}>
        <Box className={classes.container}>
          <Typography variant="h3" className={classes.lobbyTitle}>
            {title}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: 'start',
              justifyContent: 'center',
              flex: 1,
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
      <Footer />
    </Box>
  )
}
